import React, { useState } from 'react';
import API_BASE_URL from '../../config/api';

const LogoManager = ({ currentLogo, onLogoUpdate, loading, error, adminRole }) => {
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleUpload = (e) => {
    e.preventDefault();
    if (file) {
      onLogoUpdate(file);
    }
  };

  const handleRemove = () => {
    setFile(null);
    setPreview(null);
    onLogoUpdate(null);
  };

  return (
    <div className="logo-manager">
      <div className="logo-preview-section">
        <h3>Current Logo</h3>
        <div className="logo-preview">
          {currentLogo ? (
            <img src={`${API_BASE_URL}${currentLogo}`} alt="Current Logo" className="current-logo" />
          ) : (
            <div className="no-logo">No logo uploaded</div>
          )}
        </div>
      </div>

      <div className="logo-upload-section">
        <h3>Upload New Logo</h3>
        {adminRole === 'Super Admin' && (
          <div className="role-info">
            <p><strong>Super Admin:</strong> This logo will be visible to all users globally.</p>
          </div>
        )}
        {adminRole === 'Director' && (
          <div className="role-info">
            <p><strong>Director:</strong> This logo will be visible to you and your Teachers/Accountants.</p>
          </div>
        )}
        <form onSubmit={handleUpload} className="logo-upload-form">
          <div className="file-input-wrapper">
            <input
              type="file"
              id="logo-upload"
              accept="image/*"
              onChange={handleFileChange}
              className="file-input"
            />
            <label htmlFor="logo-upload" className="file-input-label">
              Choose Logo Image
            </label>
          </div>

          {preview && (
            <div className="preview-section">
              <h4>Preview</h4>
              <img src={preview} alt="Preview" className="preview-image" />
            </div>
          )}

          <div className="logo-actions">
            <button type="submit" disabled={!file || loading} className="upload-btn">
              {loading ? 'Uploading...' : 'Upload Logo'}
            </button>
            {currentLogo && (
              <button type="button" onClick={handleRemove} className="remove-btn">
                Remove Logo
              </button>
            )}
          </div>
        </form>

        {error && <div className="error">{error}</div>}
      </div>

      <div className="logo-guidelines">
        <h4>Logo Guidelines</h4>
        <ul>
          <li>Recommended size: 200x60 pixels</li>
          <li>Supported formats: JPG, PNG, GIF</li>
          <li>Maximum file size: 2MB</li>
          <li>For best results, use a transparent background</li>
        </ul>
      </div>
    </div>
  );
};

export default LogoManager;
